export type CoachLensStatus = "active" | "incomplete" | "stale" | "missing" | "unavailable";

export const LENS_STALE_THRESHOLD_DAYS = 90;
const LENS_STALE_THRESHOLD_MS = LENS_STALE_THRESHOLD_DAYS * 24 * 60 * 60 * 1000;

export interface CoachLensStatusInput {
  hasLens: boolean;         // coach_lens row exists
  hasTwin: boolean;         // coach_twin_profiles row exists
  hasFrameworks: boolean;   // at least one framework selected in the lens
  lensUpdatedAt?: string;   // ISO date of last update
  loadFailed?: boolean;
}

export function deriveCoachLensStatus(input: CoachLensStatusInput): CoachLensStatus {
  if (input.loadFailed) return "unavailable";
  if (!input.hasLens && !input.hasTwin) return "missing";
  if (input.hasLens && !input.hasFrameworks) return "incomplete";
  if (input.hasTwin && !input.hasLens) return "incomplete";
  // Stale: lens exists but hasn't been updated in 90+ days.
  // If lensUpdatedAt is undefined, we cannot determine staleness — treat as active.
  if (input.lensUpdatedAt) {
    const ageMs = Date.now() - new Date(input.lensUpdatedAt).getTime();
    if (ageMs > LENS_STALE_THRESHOLD_MS) return "stale";
  }
  return "active";
}
